import { Pipe, PipeTransform } from '@angular/core';
import { ImageDescription, MediaIdentifier } from '@fitscovery/partner/data-access';

@Pipe({ name: 'homepageSections' })
export class HomepageSectionsPipe implements PipeTransform {
    transform(sections: ImageDescription[]) {
        return sections?.filter((section: ImageDescription) => this.isHomepageSection(section));
    }

    isHomepageSection(section: ImageDescription) {
        if (section?.identifier === MediaIdentifier.ImageDescription1 ||
            section?.identifier === MediaIdentifier.ImageDescription2 ||
            section?.identifier === MediaIdentifier.ImageDescription3) {
            return true;
        } else {
            return false;
        }
    }
}
